import { BriefNotificationActionType } from "@shared/lib/types/brief";
import { IBriefInfluencerSearchRequestV2 } from "@shared/lib/types/briefInfluencerV2";
import { Button } from "@shared/ui";
import useBulkActions from "@entities/brief/lib/hooks/useBulkActions";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { Star, StarOff } from "lucide-react";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

type BulkShortlistCreatorsButtonProps = {
  mode: "shortlist" | "unshortlist";
  ids: string[];
  isSelectAll?: boolean;
  notIncludeIds?: string[];
  filterParams?: Partial<IBriefInfluencerSearchRequestV2>;
};

export function BulkShortlistCreatorsButton({
  mode,
  ids,
  isSelectAll,
  notIncludeIds,
  filterParams,
}: BulkShortlistCreatorsButtonProps) {
  const { briefId } = useBriefStore();
  const { bulkActions, isBulkActions, isBulkActionsSuccess } = useBulkActions();
  const isUnshortlist = mode === "unshortlist";

  useEffect(() => {
    if (!isBulkActionsSuccess) return;
    ToastService.success(
      isUnshortlist ? "Unshortlisting creators…" : "Shortlisting creators…"
    );
  }, [isBulkActionsSuccess, isUnshortlist]);

  const handleClick = () => {
    if (!briefId) return;
    bulkActions({
      briefId,
      actionType: isUnshortlist
        ? BriefNotificationActionType.unshortlist
        : BriefNotificationActionType.shortlist,
      ids,
      isSelectAll,
      notIncludeIds,
      filterParams: filterParams ?? {},
      actionParams: {},
    });
  };

  return (
    <Button
      type={isUnshortlist ? "default" : "primary"}
      loading={isBulkActions}
      onClick={handleClick}
      icon={isUnshortlist ? <StarOff size={14} /> : <Star size={14} />}
    >
      {isUnshortlist ? "Unshortlist" : "Shortlist"}
    </Button>
  );
}
